import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { find, get } from "lodash";
import { partnerInfo } from "~/configs/partnerDetails";
import { Delpath } from "~/utils/constants";
import { requestContentPages } from "~/store/resource/resourceAction";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const UsageRulesPage = Loadable({
  loader: () =>
    import(/* desktop */ "~/components/desktop/pages/UsageRulesTest"),
  loading: LoadableLoading
});

class DetectUsageRules extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const pathName = Delpath("/quy-dinh-su-dung");
    this.props.requestContentPages(pathName);
  }

  render() {
    return (
      <React.Fragment>
        <UsageRulesPage {...this.props} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    resource: { ContentPages }
  } = state;
  return {
    device: type,
    ContentPages
  };
};
const mapDispatchToProps = dispatch => {
  return {
    requestContentPages: pathName => dispatch(requestContentPages(pathName)) // có
  };
};
const UsageRulesHelmet = withTitle({
  component: DetectUsageRules,
  title: "Medpro | Quy định sử dụng"
});

export default connect(mapStateToProps, mapDispatchToProps)(UsageRulesHelmet);
